<div
  [ngClass]="
    type === 'courses'
      ? 'courses'
      : type === 'ilt-courses'
        ? 'ilt-courses'
        : 'learning-paths'
  "
>
  @if (type === 'ilt-courses' ? isNew && !isInProgress : isNew) {
    <div class="new status">
      {{ isNewText ? isNewText : ('common.new' | translate | lowercase) }}
    </div>
  }
  @if (isInProgress) {
    <div class="in-progress status">
      {{
        isInProgressText
          ? isInProgressText
          : ('courses.status.running' | translate)
      }}
    </div>
  }
  @if (isFinished) {
    <div
      class="completed status"
      [ngClass]="{ failed: isFailed, completed: !isFailed }"
    >
      {{
        isFinishedText
          ? isFinishedText
          : ((isFailed ? 'courses.status.failed' : 'courses.status.finished')
            | translate)
      }}
    </div>
  }
</div>
